var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
module.exports = x({ ["createStorageClient"]: () => (__WEBPACK_EXTERNAL_MODULE__edreamsodigeo_frontend_cmp_client_c74f3b82__.createStorageClient) });